import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import { formatDate } from "../../Helper/Helper";
import Spinner from "../Spinner";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";
import ShareButtons from "../ShareButtons";

function BlogDetail() {
  const { slug } = useParams();
  const [blogsDetail, setBlogsDetail] = useState({});
  const [blogsList, setBlogsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    window.scrollTo(0, 0);
    getBlogsDetail();
  }, [slug]);

  const getBlogsDetail = async () => {
    try {
      setLoading(true);
      const response = await SendPostRequest("blogs/detail", {
        slug: slug,
      });

      if (response.status === "success") {
        setBlogsList(response?.data?.lists);
        setBlogsDetail(response?.data?.detail);
      } else {
        console.warn("No service detail found in the response.");
      }
    } catch (error) {
      console.error("Error fetching services detail:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div class="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Blog Details" Image="theme-2-banner-blog.webp" />

        <section id="blog-single" className="blog-single">
          <div className="container">
            <div className="blog-main-wrap blog-list">
              <div className="row">
                <div className="col-lg-8">
                  {loading ? (
                    <div className="d-flex align-items-center justify-content-center">
                      <Spinner />
                    </div>
                  ) : (
                    <>
                      <div className="blog-wrap mb-4 pb-3">
                        <div className="blog-info-wrap">
                          <div className="blog-single-img mb-4 pb-2">
                            <img
                              // src="/assets/images/blog/blog-single.jpg"
                              src={blogsDetail?.image_url}
                              className="img-fluid b-radius-8"
                              alt="blog-img"
                            />
                          </div>
                          <div className="post-meta top-meta margin-bottom-30">
                            <ul className="nav">
                              {/* <li>
                              <a href="#">
                                <span className="author-img">
                                  <img
                                    alt=""
                                    src="/assets/images/icons/author-icon.jpg"
                                    className="avatar avatar-30 photo rounded-circle me-2"
                                    height="30"
                                    width="30"
                                  />
                                </span>
                                Jack
                              </a>
                            </li> */}
                              <li className="nav-item">
                                <div className="post-category">
                                  <span className="ti-user me-2 theme-color"></span>
                                  <Link
                                    to={`/author/detail/${blogsDetail?.author_slug}`}
                                  >
                                    {blogsDetail?.author_name}
                                  </Link>
                                </div>
                              </li>
                              <li className="nav-item">
                                <div className="post-category">
                                  <span className="ti-folder me-2 theme-color"></span>
                                  <Link>{blogsDetail?.title}</Link>
                                </div>
                              </li>
                              <li className="nav-item">
                                <div className="post-date">
                                  <span className="ti-time me-2 theme-color"></span>
                                  <a>{formatDate(blogsDetail?.date)}</a>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="blog-content pb-4 mb-2">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: blogsDetail?.content,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className="col-lg-4 ps-5 px-sm-15">
                  <div className="sidebar right-sidebar">
                    {/* <div className="widget search-widget">
                    <div className="search-form-wrapper">
                      <form className="search-form" role="search">
                        <div className="input-group add-on">
                          <input
                            className="form-control"
                            placeholder="Search for.."
                            name="srch-term"
                            type="text"
                          />
                          <div className="input-group-btn">
                            <button
                              className="btn btn-default search-btn"
                              type="submit"
                            >
                              <i className="ti-arrow-right"></i>
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div> */}
                    <div className="widget category-widget mb-3">
                      <div className="widget-title">
                        <h3 className="title">Other Blogs</h3>
                      </div>
                      <ul className="category-list">
                        {blogsList && blogsList.length > 0 ? (
                          blogsList.map((list, index) => (
                            <li key={index}>
                              <Link to={`/blog/detail/${list?.slug}`}>
                                {list?.title}
                              </Link>
                            </li>
                          ))
                        ) : (
                          <li>No other blogs found</li>
                        )}
                      </ul>

                    </div>
                    <div className="d-flex justify-content-center align-items-center">

                      <ShareButtons />
                    </div>

                    {/* <div className="widget facebook-module">
                    <div className="widget-title">
                      <h3 className="title">Authors</h3>
                    </div>
                    <div className="sidebar-facebook">
                      <ul className="facebook-inner">
                        <li>
                          <a href="#">
                            <img
                              src="/assets/images/blog/author.jpg"
                              width="70"
                              height="70"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <img
                              src="/assets/images/blog/guest.jpg"
                              width="70"
                              height="70"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <img
                              src="/assets/images/blog/author.jpg"
                              width="70"
                              height="70"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <img
                              src="/assets/images/blog/guest.jpg"
                              width="70"
                              height="70"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <img
                              src="/assets/images/blog/author.jpg"
                              width="70"
                              height="70"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <img
                              src="/assets/images/blog/guest.jpg"
                              width="70"
                              height="70"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <img
                              src="/assets/images/blog/author.jpg"
                              width="70"
                              height="70"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <img
                              src="/assets/images/blog/guest.jpg"
                              width="70"
                              height="70"
                              alt=""
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div> */}

                    {/* <div className="widget tag-cloud">
                    <div className="widget-title">
                      <h3 className="title">Tag List</h3>
                    </div>
                    <div className="tagcloud">
                      <a href="#" className="tag-cloud-link">
                        All
                      </a>
                      <a href="#" className="tag-cloud-link">
                        Commercial
                      </a>
                      <a href="#" className="tag-cloud-link">
                        Development
                      </a>
                      <a href="#" className="tag-cloud-link">
                        Residential
                      </a>
                      <a href="#" className="tag-cloud-link">
                        Kitchen
                      </a>
                      <a href="#" className="tag-cloud-link">
                        Construction
                      </a>
                      <a href="#" className="tag-cloud-link">
                        Interior
                      </a>
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FooterWrapper />
      </div>
    </div>
  );
}

export default BlogDetail;
